const DEFAULT_BRUSH_SIZE = 0.6;
const DEFAULT_LIGHTING_AMOUNT = 1.5;
const DEFAULT_SHOW_WIREFRAME = false;
const DEFAULT_SHOW_POINT_CLOUD = false;
const DEFAULT_SHOW_TOOLTIP = true;
const DEFAULT_SHOW_KEYPOINT_LABELS = false;
const DEFAULT_SHOW_TOOTH_ID_LABELS = false;
const DEFAULT_SHOW_MARGINAL_RIDGE_LINES = true;
const DEFAULT_AUTO_SAVE = true;
const KEYPOINT_LABEL_X_DISPLACEMENT = 0.5; // Displacement for keypoint label from keypoint

const CONNECTED_POINT_PAIRS = [
    ["ML_DMR", "ML_MMR"],
    ["PR_MMR", "PR_DMR"],
    ["14MMR", "14DMR"],
    ["15MMR", "15DMR"],
    ["16MMR", "16DMR"],
    ["17MMR", "17DMR"],
    ["18MMR", "18DMR"],
    ["24MMR", "24DMR"],
    ["25MMR", "25DMR"],
    ["26MMR", "26DMR"],
    ["27MMR", "27DMR"],
    ["28MMR", "28DMR"],
    ["34MMR", "34DMR"],
    ["35MMR", "35DMR"],
    ["36MMR", "36DMR"],
    ["37MMR", "37DMR"],
    ["38MMR", "38DMR"],
    ["44MMR", "44DMR"],
    ["45MMR", "45DMR"],
    ["46MMR", "46DMR"],
    ["47MMR", "47DMR"],
    ["48MMR", "48DMR"]
];

export {
    DEFAULT_BRUSH_SIZE,
    DEFAULT_LIGHTING_AMOUNT,
    DEFAULT_SHOW_WIREFRAME,
    DEFAULT_SHOW_POINT_CLOUD,
    DEFAULT_SHOW_TOOLTIP,
    DEFAULT_SHOW_KEYPOINT_LABELS,
    DEFAULT_SHOW_TOOTH_ID_LABELS,
    DEFAULT_SHOW_MARGINAL_RIDGE_LINES,
    DEFAULT_AUTO_SAVE,
    KEYPOINT_LABEL_X_DISPLACEMENT,
    CONNECTED_POINT_PAIRS
};
